import { takeLatest, all, put, call } from "redux-saga/effects"
import {
  FETCH_ESTIMATIONS_START,
  DELETE_ESTIMATION_START,
} from "./estimations.types"
import { API, graphqlOperation } from "aws-amplify"

import { listEstimations } from "../../graphql/queries"
import { deleteEstimation as deleteEstimationMutation } from "../../graphql/mutations"
import {
  fetchEstimationsStart,
  fetchEstimationsSuccess,
  fetchEstimationsError,
  deleteEstimationError,
} from "./estimations.actions"
import showErrorMessage from "../../utils/showErrorMessage"

export function* fetchEstimations() {
  try {
    const res = yield API.graphql({
      ...graphqlOperation(listEstimations),
      authMode: "API_KEY",
    })

    yield put(fetchEstimationsSuccess(res.data.listEstimations.items))
  } catch ({ errors }) {
    showErrorMessage(errors)
    yield put(fetchEstimationsError(errors))
  }
}

export function* deleteEstimation({ payload }) {
  const input = {
    id: payload,
  }

  try {
    yield API.graphql(graphqlOperation(deleteEstimationMutation, { input }))

    yield put(fetchEstimationsStart())
  } catch ({ errors }) {
    showErrorMessage(errors)

    yield put(deleteEstimationError(errors))
  }
}

export function* onFetchEstimationsStart() {
  yield takeLatest(FETCH_ESTIMATIONS_START, fetchEstimations)
}

export function* onDeleteEstimationStart() {
  yield takeLatest(DELETE_ESTIMATION_START, deleteEstimation)
}

export function* estimationsSagas() {
  yield all([call(onFetchEstimationsStart), call(onDeleteEstimationStart)])
}
